import { useEffect, useState, type CSSProperties } from 'react'
import { Clock3 } from 'lucide-react'

const MAXIMUM = 240

export function DurationRangeFilter({ minimumMinutes, maximumMinutes, onChange, label, unlimited }: {
  minimumMinutes: number | null
  maximumMinutes: number | null
  onChange: (minimum: number | null, maximum: number | null) => void
  label: string
  unlimited: string
}) {
  const [minimum, setMinimum] = useState(minimumMinutes ?? 0)
  const [maximum, setMaximum] = useState(maximumMinutes ?? MAXIMUM)

  // The catalogue view restores this filter from local preferences and can also
  // replace it through a saved filter. Keep the slider's display state in sync
  // so its initial debounce never resets a restored duration range to 0–unlimited.
  useEffect(() => {
    setMinimum(minimumMinutes ?? 0)
    setMaximum(maximumMinutes ?? MAXIMUM)
  }, [minimumMinutes, maximumMinutes])

  useEffect(() => {
    const timer = window.setTimeout(() => onChange(minimum === 0 ? null : minimum, maximum === MAXIMUM ? null : maximum), 250)
    return () => window.clearTimeout(timer)
  }, [minimum, maximum, onChange])

  const lowPercent = minimum / MAXIMUM * 100
  const highPercent = maximum / MAXIMUM * 100
  return <div className="duration-range" style={{ '--range-low': `${lowPercent}%`, '--range-high': `${highPercent}%` } as CSSProperties}>
    <div className="duration-range-title"><span><Clock3 />{label}</span><output>{minimum}–{maximum === MAXIMUM ? unlimited : maximum} Min.</output></div>
    <div className="duration-range-track">
      <input aria-label="Mindestdauer in Minuten" type="range" min="0" max={MAXIMUM} step="5" value={minimum}
        onChange={(event) => setMinimum(Math.min(Number(event.target.value), maximum - 5))} />
      <input aria-label="Höchstdauer in Minuten" type="range" min="0" max={MAXIMUM} step="5" value={maximum}
        onChange={(event) => setMaximum(Math.max(Number(event.target.value), minimum + 5))} />
    </div>
    <div className="duration-ticks"><span>0</span><span>60</span><span>120</span><span>180</span><span>{unlimited}</span></div>
  </div>
}
